import { Box } from '@mui/material';
import DataCard from 'components/data-card/data-card.component';
import { useSMSTotalsSearch } from 'pages/analytics/sms-reports/sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import { useTranslation } from 'react-i18next';

const OrderConfirmationSummaryHeader = () => {
  const { t } = useTranslation();
  const { data, isFetching } = useSMSTotalsSearch('TRANSACTIONAL');

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)' }}
      gap={2}
    >
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.orderConfirmation.summaryHeader.orderConfirmationSMSTotal.title',
        )}
        value={data?.smsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.orderConfirmation.summaryHeader.orderConfirmationSMSTotal.description',
        )}
        loading={isFetching}
        data-testid="OrderConfirmationSMSTotal.Card"
      />
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.orderConfirmation.summaryHeader.orderConfirmationSMSSegmentTotal.title',
        )}
        value={data?.segmentsTotal ?? 0}
        valueType="number"
        description={t(
          'page.reportAndAnalytics.smsReports.sections.orderConfirmation.summaryHeader.orderConfirmationSMSSegmentTotal.description',
        )}
        loading={isFetching}
        data-testid="OrderConfirmationSMSSegmentTotal.Card"
      />
    </Box>
  );
};
export default OrderConfirmationSummaryHeader;
